/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

//Mucky Nutz - Hides the cart when on Quick Order page
document.addEventListener("DOMContentLoaded", function () {
  if (window.location.pathname.includes("/apps/quick-shop")) {
    const cartIcon = document.querySelector(".secondary-nav__item--cart");

    if (cartIcon) {
      cartIcon.style.display = "none";
    }
  }
});